import Vue from "vue";
import SuiPage from "~common/components/layout/SuiPage/SuiPage";
import SuiPageHeader from "~common/components/layout/SuiPageHeader/SuiPageHeader";
import SuiPageFooter from "~common/components/layout/SuiPageFooter/SuiPageFooter";
import SuiPageContents from "~common/components/layout/SuiPageContents/SuiPageContents";
import SuiPanel from "~common/components/layout/SuiPanel/SuiPanel";
import SuiPageCardHeader from "~common/components/layout/SuiPageCardHeader/SuiPageCardHeader";
import SuiPageCardFooter from "~common/components/layout/SuiPageCardFooter/SuiPageCardFooter";
import SuiPageTabBoxType from "~common/components/form/SuiPageTabBoxType/SuiPageTabBoxType";
import SuiPageTabStepType from "~common/components/form/SuiPageTabStepType/SuiPageTabStepType";
import SuiPageTabHeadless from "~common/components/form/SuiPageTabHeadless/SuiPageTabHeadless";
import SuiSelectBox from "~common/components/form/SuiSelectBox/SuiSelectBox";
import SuiLangSelect from "~common/components/form/SuiLangSelect/SuiLangSelect";
import SuiCodeSelect from "~common/components/form/SuiCodeSelect/SuiCodeSelect";
import SuiCustomSelect from "~common/components/form/SuiCustomSelect/SuiCustomSelect";
import SuiModuleSubmoduleSelect from "~common/components/form/SuiModuleSubmoduleSelect/SuiModuleSubmoduleSelect";
import SuiYNSelect from "~common/components/form/SuiYNSelect/SuiYNSelect";
import SuiTree from "~common/components/form/SuiTree/SuiTree";
import SuiTreeGrid from "~common/components/form/SuiTreeGrid/SuiTreeGrid";
import SuiSimpleTree from "~common/components/form/SuiSimpleTree/SuiSimpleTree";
import SuiRadio from "~common/components/form/SuiRadio/SuiRadio";
import SuiShowcaseBox from "~common/components/form/SuiShowcaseBox/SuiShowcaseBox";
import SuiShowcaseTip from "~common/components/form/SuiShowcaseTip/SuiShowcaseTip";
import SuiShowcaseManualBox from "~common/components/form/SuiShowcaseManualBox/SuiShowcaseManualBox";
import SuiTextField from "~common/components/form/SuiTextField/SuiTextField";
import SuiDatePicker from "~common/components/form/SuiDatePicker/SuiDatePicker";
import SuiRangeDatePicker from "~common/components/form/SuiRangeDatePicker/SuiRangeDatePicker";
import SuiTimePicker from "~common/components/form/SuiTimePicker/SuiTimePicker";
import SuiDropdown from "~common/components/form/SuiDropdown/SuiDropdown";
import SuiCheckbox from "~common/components/form/SuiCheckbox/SuiCheckbox";
import SuiPageCardContainer from "~common/components/form/SuiPageCardContainer/SuiPageCardContainer";
import SuiPageCard from "~common/components/form/SuiPageCard/SuiPageCard";
import SuiFileUploader from "~common/components/form/SuiFileUploader/SuiFileUploader";
import SuiMultiSelect from "~common/components/form/SuiMultiSelect/SuiMultiSelect";
import SuiMultiselectPopup from "~common/components/form/SuiMultiSelectPopup/SuiMultiSelectPopup";
import SuiInputLabel from "~common/components/form/SuiInputLabel/SuiInputLabel";
import SuiConfirm from "~common/components/form/SuiConfirm/SuiConfirm";
import SuiProcessTab from "~common/components/form/SuiProcessTab/SuiProcessTab";
import SuiGridPager from "~common/components/form/SuiGridPager/SuiGridPager";
import SuiGridHeader from "~common/components/form/SuiGridHeader/SuiGridHeader";
import SuiGrid from "~common/components/form/SuiGrid/SuiGrid";
import SuiMessageBox from "~common/components/form/SuiMessageBox/SuiMessageBox";
import SuiComponentPortal from "~common/components/form/SuiComponentPortal/SuiComponentPortal";
import SuiPager from "~common/components/form/SuiPager/SuiPager";
import SuiPrompt from "~common/components/form/SuiPrompt/SuiPrompt";
import SuiPopup from "~common/components/form/SuiPopup/SuiPopup";
import SuiTabNavigator from "~common/components/form/SuiTabNavigator/SuiTabNavigator";
import SuiSampleDataset from "~common/components/form/SuiSampleDataset/SuiSampleDataset";
import SuiLnbTree from "~common/components/form/SuiLnbTree/SuiLnbTree";
import SuiMenuTree from "~common/components/form/SuiMenuTree/SuiMenuTree";
import SuiModal from "~common/components/form/SuiModal/SuiModal";
import SuiButton from "~common/components/form/SuiButton/SuiButton";
import SuiLabel from "~common/components/form/SuiLabel/SuiLabel";
import SuiLoadingIndicator from "~common/components/form/SuiLoadingIndicator/SuiLoadingIndicator";
import SuiFilterTreeview from "~common/components/form/SuiFilterTreeview/components/SuiTreeRoot";
import SuiTooltipMenu from "~common/components/form/SuiTooltipMenu/SuiTooltipMenu";
import SuiQuickLink from "~common/components/form/SuiQuickLink/SuiQuickLink";
import SuiNoticeController from "~common/components/form/SuiNoticeController/SuiNoticeController";
import SuiJqxGrid from "~common/components/form/SuiJqxGrid/SuiJqxGrid";
import SuiJqxTreeGrid from "~common/components/form/SuiJqxTreeGrid/SuiJqxTreeGrid";
import SuiTextarea from "~common/components/form/SuiTextarea/SuiTextarea";
import SuiValidator from "~common/components/form/SuiValidator/SuiValidator";
import SuiWebEditor from "~common/components/form/SuiWebEditor/SuiWebEditor";
// import CellLabel from "~common/components/gridCell/CellLabel/CellLabelView";
import SuiDiagram from "~common/components/form/SuiDiagram/components/SuiDiagram";
import SuiOrderSelectItem from "~common/components/form/SuiOrderSelectItem/SuiOrderSelectItem";
import SuiToggle from "~common/components/form/SuiToggle/SuiToggle";
import SuiSlider from "~common/components/form/SuiSlider/SuiSlider";
import SuiSpin from "~common/components/form/SuiSpin/SuiSpin";
import SuiChartBar from "~common/components/form/SuiChartBar/SuiChartBar";
import SuiChartBubble from "~common/components/form/SuiChartBubble/SuiChartBubble";
import SuiChartDounut from "~common/components/form/SuiChartDounut/SuiChartDounut";
import SuiChartHorizonBar from "~common/components/form/SuiChartHorizonBar/SuiChartHorizonBar";
import SuiChartLine from "~common/components/form/SuiChartLine/SuiChartLine";
import SuiChartPie from "~common/components/form/SuiChartPie/SuiChartPie";
import SuiChartPolar from "~common/components/form/SuiChartPolar/SuiChartPolar";
import SuiChartRadar from "~common/components/form/SuiChartRadar/SuiChartRadar";
import SuiChartScatter from "~common/components/form/SuiChartScatter/SuiChartScatter";
import SuiChartStacked from "~common/components/form/SuiChartStacked/SuiChartStacked";
import SuiDeviceCheckbox from "~common/components/form/SuiDeviceCheckbox/SuiDeviceCheckbox";
import SuiSelectPopup from "~common/components/form/SuiSelectPopup/SuiSelectPopup";
import SuiSGrid from "~common/components/form/SuiSGrid/SuiSGrid";
import MuiGrid from "~common/components/form/MuiGrid/MuiGrid";
import SuiPermissionCheckbox from "~common/components/form/SuiPermissionCheckbox/SuiPermissionCheckbox";
import SuiColorPicker from "~common/components/form/SuiColorPicker/SuiColorPicker";
import SuiKpiBoard from "~common/components/form/SuiKpiBoard/SuiKpiBoard";
import AICCPage from '~common/components/layout/AICCPage/AICCPage';
import AICCIconDropHolder from "~common/components/form/AICCIconDropHolder/AICCIconDropHolder";
import AICCScenarioProgressBar from "~common/components/form/AICCScenarioProgressBar/AICCScenarioProgressBar";
import AICCTimePicker from "~common/components/form/AICCTimePicker/AICCTimePicker";
import AICCScheduleModal from "~common/components/form/AICCScheduleModal/AICCScheduleModal";
import AICCRangePicker from "~common/components/form/AICCRangePicker/AICCRangePicker";
import AICCStepBox from "~common/components/form/AICCStepBox/AICCStepBox";
import AICCTextField from "~common/components/form/AICCTextField/AICCTextField";
import AICCTextFieldWithTimer from "~common/components/form/AICCTextFieldWithTimer/AICCTextFieldWithTimer";
import AICCTextArea from "~common/components/form/AICCTextArea/AICCTextArea";
import AICCStepper from "~common/components/form/AICCStepper/AICCStepper";
import AICCSegmentButton from "~common/components/form/AICCSegmentButton/AICCSegmentButton";
import CMP_AIC_00003 from "~modules/AI/components/CMP_AIC_00003/CMP_AIC_00003";
import CMP_AIC_00004 from "~modules/AI/components/CMP_AIC_00004/CMP_AIC_00004";
import CMP_AIU_00002 from "~modules/AI/components/CMP_AIU_00002";

class ComponentRegister {
  constructor() {
    this.componentsMap = {};
    utils.install("getComponentByName", this.getComponentByName.bind(this));
    utils.install("registComponent", this.registComponent.bind(this));
  }

  getComponentByName(componentName) {
    return this.componentsMap[componentName];
  }

  registComponent(component) {
    this.componentsMap[component.name] = component;
  }

  registCommonComponents() {
    // form
    this.componentsMap["sui-button"] = SuiButton;
    this.componentsMap["sui-checkbox"] = SuiCheckbox;
    this.componentsMap["sui-code-select"] = SuiCodeSelect;
    this.componentsMap["sui-component-portal"] = SuiComponentPortal;
    this.componentsMap["sui-confirm"] = SuiConfirm;
    this.componentsMap["sui-custom-select"] = SuiCustomSelect;
    this.componentsMap["sui-date-picker"] = SuiDatePicker;
    this.componentsMap["sui-diagram"] = SuiDiagram;
    this.componentsMap["sui-dropdown"] = SuiDropdown;
    this.componentsMap["sui-file-uploader"] = SuiFileUploader;
    this.componentsMap["sui-filter-treeview"] = SuiFilterTreeview;
    this.componentsMap["sui-grid"] = SuiGrid;
    this.componentsMap["sui-grid-header"] = SuiGridHeader;
    this.componentsMap["sui-grid-pager"] = SuiGridPager;
    this.componentsMap["sui-input-label"] = SuiInputLabel;
    this.componentsMap["sui-jqx-grid"] = SuiJqxGrid;
    this.componentsMap["sui-jqx-tree-grid"] = SuiJqxTreeGrid;
    this.componentsMap["sui-label"] = SuiLabel;
    this.componentsMap["sui-lang-select"] = SuiLangSelect;
    this.componentsMap["sui-lnb-tree"] = SuiLnbTree;
    this.componentsMap["sui-loading-indicator"] = SuiLoadingIndicator;
    this.componentsMap["sui-menu-tree"] = SuiMenuTree;
    this.componentsMap["sui-message-box"] = SuiMessageBox;
    this.componentsMap["sui-modal"] = SuiModal;
    this.componentsMap[
      "sui-module-submodule-select"
    ] = SuiModuleSubmoduleSelect;
    this.componentsMap["sui-multi-select"] = SuiMultiSelect;
    this.componentsMap["sui-multi-select-popup"] = SuiMultiselectPopup;
    this.componentsMap["sui-notice-controller"] = SuiNoticeController;
    this.componentsMap["sui-order-select-item"] = SuiOrderSelectItem;
    this.componentsMap["sui-page-card"] = SuiPageCard;
    this.componentsMap["sui-page-card-container"] = SuiPageCardContainer;
    this.componentsMap["sui-pager"] = SuiPager;
    this.componentsMap["sui-page-tab-box-type"] = SuiPageTabBoxType;
    this.componentsMap["sui-page-tab-headless"] = SuiPageTabHeadless;
    this.componentsMap["sui-page-tab-step-type"] = SuiPageTabStepType;
    this.componentsMap["sui-popup"] = SuiPopup;
    this.componentsMap["sui-process-tab"] = SuiProcessTab;
    this.componentsMap["sui-prompt"] = SuiPrompt;
    this.componentsMap["sui-quick-link"] = SuiQuickLink;
    this.componentsMap["sui-radio"] = SuiRadio;
    this.componentsMap["sui-range-date-picker"] = SuiRangeDatePicker;
    this.componentsMap["sui-sample-dataset"] = SuiSampleDataset;
    this.componentsMap["sui-select-box"] = SuiSelectBox;
    this.componentsMap["sui-showcase-box"] = SuiShowcaseBox;
    this.componentsMap["sui-showcase-manual-box"] = SuiShowcaseManualBox;
    this.componentsMap["sui-showcase-tip"] = SuiShowcaseTip;
    this.componentsMap["sui-spin"] = SuiSpin;
    this.componentsMap["sui-slider"] = SuiSlider;
    this.componentsMap["sui-simple-tree"] = SuiSimpleTree; // sui-tree로 변경 할 경우 중복.
    this.componentsMap["sui-tab-navigator"] = SuiTabNavigator;
    this.componentsMap["sui-textarea"] = SuiTextarea;
    this.componentsMap["sui-text-field"] = SuiTextField;
    this.componentsMap["sui-time-picker"] = SuiTimePicker;
    this.componentsMap["sui-tooltip-menu"] = SuiTooltipMenu;
    this.componentsMap["sui-tree-grid"] = SuiTreeGrid;
    this.componentsMap["sui-tree"] = SuiTree;
    this.componentsMap["sui-web-editor"] = SuiWebEditor;
    this.componentsMap["sui-yn-select"] = SuiYNSelect;
    this.componentsMap["sui-toggle"] = SuiToggle;
    this.componentsMap["sui-validator"] = SuiValidator;
    this.componentsMap["sui-chart-bar"] = SuiChartBar;
    this.componentsMap["sui-chart-bubble"] = SuiChartBubble;
    this.componentsMap["sui-chart-dounut"] = SuiChartDounut;
    this.componentsMap["sui-chart-hbar"] = SuiChartHorizonBar;
    this.componentsMap["sui-chart-line"] = SuiChartLine;
    this.componentsMap["sui-chart-pie"] = SuiChartPie;
    this.componentsMap["sui-chart-polar"] = SuiChartPolar;
    this.componentsMap["sui-chart-radar"] = SuiChartRadar;
    this.componentsMap["sui-chart-scatter"] = SuiChartScatter;
    this.componentsMap["sui-chart-stacked"] = SuiChartStacked;
    this.componentsMap["sui-device-checkbox"] = SuiDeviceCheckbox;
    this.componentsMap["sui-select-popup"] = SuiSelectPopup;
    this.componentsMap["sui-s-grid"] = SuiSGrid;
    this.componentsMap["mui-grid"] = MuiGrid;
    this.componentsMap["sui-permission-checkbox"] = SuiPermissionCheckbox;
    this.componentsMap["sui-color-picker"] = SuiColorPicker;
    this.componentsMap["sui-kpi-board"] = SuiKpiBoard;
    // AICC Custom Components
    this.componentsMap["aicc-page"] = AICCPage;
    this.componentsMap["aicc-icon-drop-holder"] = AICCIconDropHolder;
    this.componentsMap["aicc-scenario-progress-bar"] = AICCScenarioProgressBar;
    this.componentsMap["aicc-time-picker"] = AICCTimePicker;
    this.componentsMap["aicc-conversation-modal"] = CMP_AIC_00003;
    this.componentsMap["aicc-recording-modal"] = CMP_AIC_00004;
    this.componentsMap["aicc-user-modal"] = CMP_AIU_00002;
    this.componentsMap["aicc-schedule-modal"] = AICCScheduleModal;
    this.componentsMap["aicc-range-picker"] = AICCRangePicker;
    this.componentsMap["aicc-step-box"] = AICCStepBox;
    this.componentsMap["aicc-text-field"] = AICCTextField;
    this.componentsMap["aicc-text-field-with-timer"] = AICCTextFieldWithTimer;
    this.componentsMap["aicc-text-area"] = AICCTextArea;
    this.componentsMap["aicc-stepper"] = AICCStepper;
    this.componentsMap["aicc-segment-button"] = AICCSegmentButton;
    
    // layout
    this.componentsMap["sui-page"] = SuiPage;
    this.componentsMap["sui-page-header"] = SuiPageHeader;
    this.componentsMap["sui-page-footer"] = SuiPageFooter;
    this.componentsMap["sui-page-contents"] = SuiPageContents;
    this.componentsMap["sui-panel"] = SuiPanel;
    this.componentsMap["sui-page-card-header"] = SuiPageCardHeader;
    this.componentsMap["sui-page-card-footer"] = SuiPageCardFooter;

    // grid cell component
    // this.componentsMap["sui-grid-cell-label"] = CellLabel;

    _.forEach(this.componentsMap, (component, name) => {
      Vue.component(name, component);
    });
  }
}

export default new ComponentRegister();